export const JSON_ONE31 = {
   
  
    "ag_id": "paygate",
    "me_id": "202104210302",
    "request_type": "Check Transaction Status",
    "cust_account_number": "5323445678136109",
    "Txn_date_range": "01-08-2021 to 02-09-2021"
    }



